import { addNavMenuItem } from "@vendure/admin-ui/core";

export default [
    addNavMenuItem(
        {
            id: 'career-ticket',
            label: 'Career Tickets',
            routerLink: ['/extensions/careers'],
            icon: 'inbox',
        },
        'feedbacks',
    ),
];
